import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
  return // disable sentry

  if (process.env.NODE_ENV === 'production') {
    const router = useRouter()
    const {
      public: { sentry }
    } = useRuntimeConfig()

    if (!sentry.dsn) {
      return
    }

    Sentry.init({
      app: nuxtApp.vueApp,
      dsn: sentry.dsn,
      environment: sentry.environment,

      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration()
      ],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,

      // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],

      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,

      ...(sentry.clientOptions ? sentry.clientOptions : {})
    })
  }
})
